module.exports = __webpack_public_path__ + "assets/img/safe_2.f74e0ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./website/assets/safe_2.jpg
// module id = gEoq
// module chunks = 0